// Colors for theming
export const colors = {
  green: {
    lightest: "rgba(220, 255, 209, 0.3)", // More yellow-green
    light: "rgba(180, 255, 160, 0.5)", // Warmer light green
    medium: "rgba(140, 255, 100, 0.7)", // Warmer medium green
    dark: "rgba(100, 220, 50, 0.85)", // Warmer dark green
    darkest: "rgba(80, 180, 20, 1)", // Warmer intense green
  },
  red: {
    lightest: "rgba(255, 209, 209, 0.3)",
    light: "rgba(255, 170, 170, 0.5)",
    medium: "rgba(255, 127, 127, 0.7)",
    dark: "rgba(255, 80, 80, 0.85)",
    darkest: "rgba(255, 50, 50, 1)",
  },
  yellow: {
    lightest: "rgba(255, 215, 0, 0.2)",
    light: "rgba(255, 215, 0, 0.4)",
    medium: "rgba(255, 215, 0, 0.6)",
    dark: "rgba(255, 215, 0, 0.8)",
    darkest: "rgba(255, 212, 0, 1)",
  },
};
